// Import vendor dependencies
import * as angular from 'angular';
import * as angularAria from 'angular-aria';
import * as angularAnimate from 'angular-animate';
import * as uiTooltip from 'angular-ui-bootstrap/src/tooltip';
import * as uiDropdown from 'angular-ui-bootstrap/src/dropdown';
import * as angulartics from 'angulartics';
import * as angularticsGoogleAnalytics from 'angulartics-google-analytics';
import * as angularTranslate from 'angular-translate';
import 'angular-translate-loader-static-files';
import 'bootstrap-css-only';
import 'angular-material/modules/js/core/core.css';
import 'go-styles/src/goreact-style.less';

import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
import * as relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

import { appRunModule } from 'go-modules/app-run';
import { sessionManager } from 'go-modules/session-manager';
import { goPubnubModule } from 'go-modules/go-pubnub';
import { analyticsModule } from 'go-modules/services/analytics';
import { fineUploaderModule } from 'go-modules/fine-uploader';
import { mediaPlayerModule } from 'go-modules/media-player';
import { uibModalDecoratorModule } from 'go-modules/$uib-modal-decorator';
import { common } from 'go-modules/models/common';
import { updateManagerModule } from 'go-modules/update-manager';

// App configuration
import { ENVIRONMENT_CONSTANTS } from './environment';
import {
	environmentLoggingConfig,
	compileProviderConfig,
	unhandledRejectionConfig
} from './config';
import {
	animationsRunBlock,
	initializeWizardRunBlock,
	addUnsavedTranscriptionUsage,
	initFullstory,
	initGoogleAnalytics,
	initPubnub,
	initBannerNotifications,
	initFineUploader,
	setFavicon
} from './run';


// App modules
import { routeViewsModule } from './route-views';
import { wizardModule } from './wizard';
import { accountEditorModule } from '@lti/app/components/account-editor';
import { fullstoryModule } from 'go-modules/services/fullstory';
import { userModel } from 'go-modules/models/user';
import { bannerNotificationsModule } from 'go-modules/services/banner-notifications';
import { watsonUsageTrackingModule } from 'go-modules/services/watson-usage-tracking';
import { SelectedModule } from 'go-modules/services/selected';
import { goPageModule } from 'go-modules/go-page';
import { goLocalizeHelperModule } from 'go-modules/translation-helper';
import { TranslateService } from '@ngx-translate/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import { eventServiceModule } from '@go-modules/services/event';
import { ngxGoModalServiceModule } from '@go-modules/services/go-modal';
import { groupSettingsPanelModule } from 'go-modules/group-settings-panel';
import { ngxLicenseSeatsManagementModule } from '@go-modules/components/license-seats-management';
import { ngxUserSessionExpirationModule } from '@lti/app/components/user-session-expiration';
import { ngxArchiveViewModule } from '@go-modules/components/archive/archive-view';
// Circular dependency
import /*{ activityEditorPanelModule } from*/ 'go-modules/activity-editor-panel';
import { ngxIframeBannerModule } from '@lti/app/components/iframe-banner';
import { ngxTaskServiceModule } from '@go-modules/services/task';
import { routeResolverServiceModule } from '@go-modules/services/routing';
import { ngxRouterServiceModule } from '@go-modules/services/router';
import { sessionCreationWizardModule } from 'go-modules/session-creation-wizard';
import { sessionEditorPanelModule } from 'go-modules/session-editor-panel';
import { dashboardServicesModule } from 'dashboard/services';
import { Router } from '@angular/router';

export const appModule: string = angular
	.module('app', [
		goLocalizeHelperModule,
		routeViewsModule,
		wizardModule,
		accountEditorModule,
		angularAria,
		angularAnimate,
		uiDropdown,
		uiTooltip,
		angularTranslate,
		angulartics,
		angularticsGoogleAnalytics,
		sessionManager,
		goPubnubModule,
		analyticsModule,
		fineUploaderModule,
		mediaPlayerModule,
		ngxUserSessionExpirationModule,
		appRunModule,
		uibModalDecoratorModule,
		common,
		updateManagerModule,
		fullstoryModule,
		userModel,
		bannerNotificationsModule,
		watsonUsageTrackingModule,
		goPageModule,
		SelectedModule,
		eventServiceModule,
		ngxGoModalServiceModule,
		ngxLicenseSeatsManagementModule,
		ngxArchiveViewModule,
		// imported for expiring license component
		// we dont ever actually want to show groupsettingspanel in lti
		groupSettingsPanelModule,
		ngxRouterServiceModule,
		'activity-editor-panel',
		ngxIframeBannerModule,
		ngxTaskServiceModule,
		routeResolverServiceModule,
		sessionCreationWizardModule,
		sessionEditorPanelModule,
		dashboardServicesModule
	])
	.constant('ENVIRONMENT_CONSTANTS', ENVIRONMENT_CONSTANTS)
	.config(unhandledRejectionConfig)
	.config(environmentLoggingConfig)
	.config(compileProviderConfig)
	.run(setFavicon)
	.run(animationsRunBlock)
	.run(initializeWizardRunBlock)
	.run(addUnsavedTranscriptionUsage)
	.run(initFullstory)
	.run(initPubnub)
	.run(initFineUploader)
	.run(initGoogleAnalytics)
	.run(initBannerNotifications)
	.factory('ngxTranslationService', downgradeInjectable(TranslateService))
	.factory('ngRouter', downgradeInjectable(Router))
	.name;
